module.exports = {"8A Program Participant":"8A Program Participant","Minority Owned":"Minority Owned","SBA Certified Hubzone Firm":"SBA Certified Hubzone Firm","Service-Disabled Veteran-Owned Small Business":"Service-Disabled Veteran-Owned Small Business","Small Business":"Small Business","Small Disadvantaged Business":"Small Disadvantaged Business","Veteran Owned":"Veteran Owned","Woman Owned":"Woman Owned"}


//////////////////
// WEBPACK FOOTER
// ./src/config/businessClassifications.json
// module id = 5252
// module chunks = 1